import { Component, OnInit, ViewChild, ElementRef, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import * as Hls  from "hls.js";
import * as Plyr from "plyr";
import { DCInput } from '../dynamic_components/dynamic.service';
import { DialogService } from "../dynamic_components/dialog/dialog.service";
import { EPG_list } from '../iptv-epg/epg.interfaces';
import { Channel } from '../IPTV_Editor/iptv_editor.component';
import { EpgWindowService } from '../iptv-epg/epg_window.service';

@Component({
  selector: 'iptv-video',
  templateUrl: './iptv-video.component.html',
  styleUrls: ['./iptv-video.component.css']
})
export class IptvVideoComponent implements OnInit, OnDestroy, AfterViewInit, DCInput {
  title="Видео Проигрыватель!";
  destroyEmitter = new EventEmitter<null>();
  /**
   * Библиотека HLS для воспроизведения потокового видео IPTV
   */
  private _hls:Hls = null;
  /**
   * Обертка плеера Plyr
   */
  private _plyr:Plyr = null;
  /**
   * Продолжительность программы передач в секундах. Используется для отображения временной метки, при наведении курсора над ползунком
   */
  private duration:number = 60*60;
  /**
   * Время в секундах, просмотренные в предыдущей передачи.
   * Для следующей передачи это время отнимается.
   * Необходимо для перемещиения ползунка, в зависимости от просмотриваемой передачи.
   */
  private prevTimer:number = 0;
  /**
   * Ползунок хронологии просмотра программы в плеере.
   */
  private seek:HTMLInputElement = null;
  /**
   * Автозапуск канала.
   */
  public autoplay = true;
  @ViewChild("video",  {static: true}) videoElement:ElementRef = null;
  @ViewChild("videoContainer",  {static: true}) videoContainer:ElementRef = null;

  /**
   * Включаемый канал
   */
  public channel:Channel = null;
  /**
   * EPG проигрываемой передачи.
   */
  epgCurrent:EPG_list = null;

  constructor(private _dialog:DialogService, private _EPGService:EpgWindowService) {
    this.epgCurrent = {start: Math.floor(((new Date()).getTime()-30*60*1000)/1000),
                      stop: Math.floor(((new Date()).getTime()+30*60*1000)/1000),
                      programm: "Нет телепрограммы",
                      progress: 50
    }
   }
  ngOnInit(){
    this._plyr = new Plyr(this.videoElement.nativeElement,{
      controls: ['play-large', 'play', 'progress', 'mute', 'volume', 'pip', 'airplay', 'fullscreen'],
      loadSprite: false,
      iconUrl: "/iptv/editor/assets/plyr.svg",
      blankVideo: "/iptv/editor/assets/blank.mp4"
    });
  }
  ngAfterViewInit(){
  }
  ngOnDestroy(){
    if(this.epgCurrent && this.epgCurrent.chronology != "current"){
      this.epgCurrent.progress = 0;
    }
    this._EPGService.set_played_programm(null);
    this._hls?.destroy();
    this._plyr?.destroy();
    this.destroyEmitter.complete();
  }
  /**
   * Инициализация плеереа обертки Plyer. Вводит необходимые измения для работы EPG.
   */
  public plyr_epg_init(){
    if(this.channel) {
      this.title = this.channel.name;
      (<any>this._plyr).config.duration =  this.duration;
      // Убераем табуляцию, чтобы курсор не переходил в плеер, така как потом появляются ошибки, если перемещаться стрелками.
      (<any>this._plyr).elements.container.tabIndex = "-1"
      // Клонируем ползунок, и заменяем оригинальный, чтобы Plyr им не управлял.
      let seekPlyr = (<any>this._plyr).elements.inputs.seek;
      this.seek = seekPlyr.cloneNode(true);
      seekPlyr.parentNode.replaceChild(this.seek, seekPlyr);
      // Передвигаем ползунок прогресса, в зависимости от времени просмотра, текущей передачи
      let progress = 0
      this.videoElement.nativeElement.addEventListener('timeupdate', event => {
        if(!event.target.paused && this.duration){
          progress = this.epgCurrent.progress + (((event.target.currentTime - this.prevTimer)/this.duration)*100);
          this.seek.value = progress.toString();
          (<any>this.seek).style = `--value:${progress}%`;

          // Тестирование Времени
          // let time = Math.floor((progress/100)*this.duration),
          //     minutes = Math.floor(time/60),
          //     seconds = Math.floor(time-(minutes*60));
          // console.log(`${minutes}:${seconds}`);

          if(progress >= 100){
            const next_epg = this._EPGService.get_next_epg(this.epgCurrent, this.channel);
            if(next_epg) {
              this.epgCurrent.progress = 0; // Для того чтобы в списке EPG на день, ползунок находился в начале.
              this.epgCurrent = next_epg;
              this.epgCurrent.progress = 0;
              this.prevTimer = event.target.currentTime;
              this.plyr_update_interval();
            }
          } 
        }
      });

      // При перемещении ползунка, меняем левый пройденный диапазон
      this.seek.addEventListener("input", event => {
        (<any>this.seek).style = `--value:${this.seek.value}%`;
      });

      // Запуск канала из архива, по клику ползунка.
      this.seek.addEventListener('change', event => {
        const start = Math.floor(this.epgCurrent.start),
              stop = Math.floor(this.epgCurrent.stop),
              playTime = start + Math.floor((parseFloat(this.seek.value)/100) * (stop - start)),
              lutc = Math.floor((new Date()).getTime()/1000),
              url = this.channel.url.indexOf("?") > 0 ? this.channel.url+`&utc=${playTime}&lutc=${lutc}` : 
                                                        this.channel.url+`?utc=${playTime}&lutc=${lutc}`;
        if(playTime < lutc) {
          this.epgCurrent.progress = parseFloat(this.seek.value);
          // console.log(new Date(playTime*1000), url);
          this.play(url);
        } else {
          this._plyr.play();
        }
      });

      // Ставим на паузу, иначе из-за timeupdate ползунок возвращается в исходное положение.
      this.seek.addEventListener('mousedown', ()=>{
        this.videoElement.nativeElement.pause();
      });
      this.seek.addEventListener('touchstart', ()=>{
        this.videoElement.nativeElement.pause();
      });
  
      // Вставляем елементы временных меток начала и конца программы.
      const progressContainer = document.getElementsByClassName("plyr__progress__container")[0],
      startDiv = document.createElement("div"),
      stopDiv = document.createElement("div");
      startDiv.className = stopDiv.className = "plyrTimeProgramm";
      startDiv.id = "plyrStartTimeProgramm";
      stopDiv.id = "plyrStopTimeProgramm";
      progressContainer.after(stopDiv);
      progressContainer.before(startDiv);
    }
  }
  /**
   * Plyr Указываем временные метки и продолжительность программы.
   */
  public plyr_update_interval(){
    if(this.epgCurrent && this.epgCurrent.stop){
      this.duration = this.epgCurrent.stop - this.epgCurrent.start;
      (<any>this._plyr).config.duration = this.duration;
      document.getElementById("plyrStartTimeProgramm").innerText = this.format_bi_numbers((new Date(this.epgCurrent.start*1000)).getHours()) + ":" + this.format_bi_numbers((new Date(this.epgCurrent.start*1000)).getMinutes()); 
      document.getElementById("plyrStopTimeProgramm").innerText = this.format_bi_numbers((new Date(this.epgCurrent.stop*1000)).getHours()) + ":" + this.format_bi_numbers((new Date(this.epgCurrent.stop*1000)).getMinutes()); 
    } else {
      (<any>this._plyr).config.duration = 60*60;
    }
  }
  /**
   * Инициализация объекта HLS, который обрабатывает и воспроизводить IPTV ссылки
   */
  private hls_init() {
    const  videoHTML:HTMLVideoElement = this.videoElement.nativeElement;
    if(this._hls) {
      this._hls.destroy(); // Если меняется источник для плеера, то объект HLS надо уничтожить и создать заново.
    }
    this._hls = new Hls();

    this._hls.on(Hls.Events.MEDIA_ATTACHED,()=> {

      this._hls.on(Hls.Events.ERROR, (event, data) => {
        // console.log(data);
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log("Сетевая ошибка");
              if (data.networkDetails?.status == 403) {
                this._dialog.alert("Воспроизвести нельзя. Пакет IPTV не активирован!");
              } else {
                this._dialog.alert("Воспроизвести нельзя. Произошла сетевая ошибка!");
              }
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log("Медиа ошибка");
              this._dialog.alert("К сожалению нельзя воспроизвести!");
              this._hls.recoverMediaError();
              break;
            default:
              this._dialog.alert("К сожалению нельзя воспроизвести!");
              break;
          }
          this.close();
        }
      });

      // if(this.autoplay) {
      //   videoHTML.play().then(()=>{
      //     //videoHTML.requestFullscreen(); // При запуске разворачивает окно плеера
      //   }, (e:DOMException)=>{ 
      //     console.log("Play Video: "+e.message);
      //    });
      // }
      // В title вписываем разрешение канала
      videoHTML.addEventListener("play",(e:Event)=>{
        if(this.title.charAt(this.title.length-1) !== "]"){
          this.title += ` [${videoHTML.videoWidth}:${videoHTML.videoHeight}]`;
        }
      })
    });

    this.prevTimer = 0;
  }
  /**
   * Приводит число n к форме 0n
   */
  private format_bi_numbers(n:number):string{
    if(n<10) return "0"+n;
    return n.toString();
  }
  close(){
    this.destroyEmitter.emit(null);
  }
  /**
   * Запускает видео 
   * @param url Если не передана ссылка, тогда берется url из объекта Channel
   */
  play(url?:string){
    const  videoHTML:HTMLVideoElement = this.videoElement.nativeElement;
    url = url ? url : this.channel?.url;
    // Если запускается не канал, то воспроизводим его как video
    if(!this.channel){
      videoHTML.src = url;
      // Для того чтобы не отображалось EPG в нижней части плеера, выставляем в null
      this.epgCurrent = null;
    } else if(Hls.isSupported()) {
      this.hls_init();
      this._hls.loadSource(url);
      this._hls.attachMedia(videoHTML); 
    } else {
      this._dialog.alert("В вашем браузере не поддерживается HLS");
      this.close();
    }
  }
  /**
   * Разворачивает контейнер плеера на весь экран и обратно.
   * Используется при навигации стрелочными кнопками.
   */
  fullScreen(){
    // this._plyr.fullscreen.toggle();
    if(document.fullscreenElement){
      document.exitFullscreen();
    } else if (this.videoContainer && "requestFullscreen" in this.videoContainer.nativeElement ){
      this.videoContainer.nativeElement.requestFullscreen();
    }
  }
  /**
   * Отображает программу передач на день.
   */
  epg_day(){
    this.epgCurrent.progress = parseFloat(this.seek.value);
    this._EPGService.set_played_programm(this.epgCurrent);
    this._EPGService.show(this.channel);
  }

}
